// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 18:53:46
import { ListTaskStatus_abstract } from './../abstract/SagaStateLib/ListTaskStatus_abstract';
export class ListTaskStatus extends ListTaskStatus_abstract {}
